module.exports = __webpack_public_path__ + "fonts/DMSans-MediumItalic.a2a143d6.ttf";